<app-navbar></app-navbar>

<br>

<div  style="background-color:#f5f5f5;width:99%;" class="mx-auto d-block">
    <div class="container-fluid" style="width:99%">
        <div class="row" > 
            <div class="col-md-2">

            </div>
            <div class="col-md-8"  >
                <mat-card>
                <div class="col-md-10 px-0 " >
                    <p class="aetnaMainDiv" class="break-msg" style="word-break: break-word;"> 
                       
                        <span *ngIf="displayPendingMSG">Please submit the {{roleDesc}} <a class="aetnaMainDiv" routerLink={{fileName}}><u>Questionnaire</u></a>. Aetna Interoperability Team will review and approve your Subscription request.
                       
                          
                       
                        </span>
                       
                        <span *ngIf="role=='2'">
                            <br>
                            Note: This role is intended only for brokers with an established Aetna Medicare NextGen partnership. Access is limited to Medicare Provider Directory API.
                         </span>

                        <span *ngIf="!displayPendingMSG">
                           {{withoutQuesntionireMsg}}
                        </span>


                       <br> 
                    
                     
                    </p>
                  
                </div> 
            </mat-card>
            </div>
            <div class="col-md-2">

            </div>
        </div>
    </div>   
</div>



